export const svgToPng = (svgText: string, margin: number, fill: string | undefined): Promise<string> => {
    return new Promise((resolve, reject) => {
        try {
            var domUrl = window.URL || window.webkitURL || window;
            if (!domUrl) {
                throw new Error("(browser doesnt support this)")
            }
        
            let match = svgText.match(/height=\"(\d+)/m);
            const height = match && match[1] ? parseInt(match[1],10) : 160;
            match = svgText.match(/width=\"(\d+)/m);
            const width = match && match[1] ? parseInt(match[1],10) : 416;
            margin = margin || 0;
        
            if (!svgText.match(/xmlns=\"/mi)){
                svgText = svgText.replace ('<svg ','<svg xmlns="http://www.w3.org/2000/svg" ');
            }
        
            let canvas = document.createElement("canvas");
            canvas.height = height+margin*2;
            canvas.width = width+margin*2;
            const ctx = canvas.getContext("2d");
        
            const svg = new Blob([svgText], {
            type: "image/svg+xml;charset=utf-8"
            });
        
            const url = domUrl.createObjectURL(svg);
        
            const img = new Image;
        
            img.onload = function() {
                //@ts-ignore
                ctx.drawImage(this, margin, margin);
          
                if (fill) {
                    const styled = document.createElement("canvas");
                    styled.width = canvas.width;
                    styled.height = canvas.height;
                    const styledCtx = styled.getContext("2d");
                    if(styledCtx) {
                        styledCtx.save();
                        styledCtx.fillStyle = fill;   
                        styledCtx.fillRect(0,0,canvas.width,canvas.height);
                        styledCtx.strokeRect(0,0,canvas.width,canvas.height);
                        styledCtx.restore();
                        styledCtx.drawImage (canvas, 0,0);
                    }
                    canvas = styled;
                }
                domUrl.revokeObjectURL(url);
                const png = canvas.toDataURL()
                resolve(png);
            };
        
            img.src = url;
        } catch (err) {
            reject('failed to convert svg to png ' + err);
        }
    });
};

export const dataUrlToFile = async (dataUrl: string, fileName: string, fileType: string) => {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: fileType });
}
export const FileToUri = (file: File) => URL.createObjectURL(file)